<c-toast-header
  [closeButton]="closeButton"
  class="app-realtime-toast__hdr border-0 pb-0"
>
  <div class="app-realtime-toast__hdr-inner">
    @if (iconName) {
      <div
        class="app-realtime-toast__icon"
        [attr.data-tone]="color || 'info'"
        aria-hidden="true"
      >
        <svg cIcon [name]="iconName" size="lg"></svg>
      </div>
    }
    <div class="app-realtime-toast__hdr-text min-w-0">
      @if (categoryLabel) {
        <span class="app-realtime-toast__chip">{{ categoryLabel }}</span>
      }
      <strong class="app-realtime-toast__ttl text-truncate d-block">{{
        title
      }}</strong>
    </div>
  </div>
</c-toast-header>
<c-toast-body
  #toastBody
  [cToastClose]="toastBody.toast"
  class="app-realtime-toast__bd pt-2"
>
  @if (subtitle) {
    <p class="app-realtime-toast__sub small text-body-secondary mb-2">
      {{ subtitle }}
    </p>
  }
  <p class="app-realtime-toast__lead fw-semibold text-body mb-2">
    {{ body }}
  </p>
  @if (lines?.length) {
    <dl class="app-realtime-toast__dl mb-3">
      @for (row of lines; track row.label + row.value) {
        <div class="app-realtime-toast__dl-row">
          <dt>{{ row.label }}</dt>
          <dd [title]="row.value">{{ row.value }}</dd>
        </div>
      }
    </dl>
  }
  <div class="app-realtime-toast__foot d-flex align-items-center gap-2 flex-wrap">
    @if (timeLabel) {
      <span class="app-realtime-toast__time small text-body-secondary"
        >Recibido · {{ timeLabel }}</span
      >
    }
    @if (link && link.length) {
      <a
        class="btn btn-sm btn-primary app-realtime-toast__cta ms-auto"
        [routerLink]="link"
        >Ver detalle</a
      >
    }
  </div>
</c-toast-body>
